import { gql } from '@apollo/client';
import { apolloClient } from '../apollo/client';
import { Equipe } from '../types/equipe';

export const EQUIPES_POR_CATEGORIA_TORNEIO = gql`
  query EquipesPorCategoriaTorneio($categoriaTorneioId: ID!) {
    equipesPorCategoriaTorneio(categoriaTorneioId: $categoriaTorneioId) {
      id
      nome
      cidade
      criadoEm
      atualizadoEm
      partidasCategoriaTorneio
      atletas {
        id
        usuario {
          id
          nome
          username
          imagemUrl
        }
        cidade {
          id
          nome
          uf
        }
      }
    }
  }
`;

export interface EquipesPorCategoriaTorneioData {
  equipesPorCategoriaTorneio: Equipe[];
}

export interface EquipesPorCategoriaTorneioVars {
  categoriaTorneioId: string;
}

export async function buscarEquipesPorCategoriaTorneio(
  categoriaTorneioId: string,
): Promise<Equipe[]> {
  const { data } = await apolloClient.query<
    EquipesPorCategoriaTorneioData,
    EquipesPorCategoriaTorneioVars
  >({
    query: EQUIPES_POR_CATEGORIA_TORNEIO,
    variables: { categoriaTorneioId },
    fetchPolicy: 'no-cache',
  });

  return data?.equipesPorCategoriaTorneio ?? [];
}

export default { buscarEquipesPorCategoriaTorneio };
